import { Pipe, PipeTransform } from '@angular/core';

/**
 * Class for filter list by key
 */
@Pipe({
    name: 'rmsSortByMultiPure',
    standalone: false
})

export class RmsSortByMultiPurePipe implements PipeTransform {

  transform<T>(array: Array<T>, field: string, order?: string, defaultField?: string): Array<T> {
    if ( array && field ) {
      const arrayNulls = [];
      const arrayPending = [];
      let result = null;
      array.forEach( item => {
        let value = null;
        if ( field.indexOf('.') === -1 ) {
          value = item[field];
        } else if (item[field.split('.')[0]]) {
          value = item[field.split('.')[0]][field.split('.')[1]];
        }
        if (value !== null && value !== undefined) {
          arrayPending.push(item);
        } else {
          arrayNulls.push(item);
        }
      });
      arrayPending.sort((a: any, b: any) => {
        let nameA = null;
        let nameB = null;
        if ( field.indexOf('.') === -1 ) {
          nameA = a[field];
          nameB = b[field];
        } else if ( a[field.split('.')[0]] && b[field.split('.')[0]] ) {
          nameA = a[field.split('.')[0]][field.split('.')[1]];
          nameB = b[field.split('.')[0]][field.split('.')[1]];
        }
        if ( order && order !== 'DESC' ) {
          if (nameA === null || nameA > nameB) {
            return 1;
          } else if (nameA < nameB) {
            return -1;
          } else {
            if (defaultField) {
              nameA = null;
              nameB = null;
              if ( defaultField.indexOf('.') === -1 ) {
                nameA = a[defaultField];
                nameB = b[defaultField];
              } else if ( a[defaultField.split('.')[0]] && b[defaultField.split('.')[0]] ) {
                nameA = a[defaultField.split('.')[0]][defaultField.split('.')[1]];
                nameB = b[defaultField.split('.')[0]][defaultField.split('.')[1]];
              }
              if (nameA === null || (nameB !== null && nameA > nameB)) {
                return 1;
              } else if (nameB === null || nameA < nameB) {
                return -1;
              }
            }
            return 0;
          }
        } else {
          if (nameA === null || nameA > nameB) {
            return -1;
          } else if (nameA < nameB) {
            return 1;
          } else {
            if (defaultField) {
              nameA = null;
              nameB = null;
              if ( defaultField.indexOf('.') === -1 ) {
                nameA = a[defaultField];
                nameB = b[defaultField];
              } else if ( a[defaultField.split('.')[0]] && b[defaultField.split('.')[0]] ) {
                nameA = a[defaultField.split('.')[0]][defaultField.split('.')[1]];
                nameB = b[defaultField.split('.')[0]][defaultField.split('.')[1]];
              }
              if (nameA === null || (nameB !== null && nameA > nameB)) {
                return -1;
              } else if (nameB === null || nameA < nameB) {
                return 1;
              }
            }
            return 0;
          }
        }
      });
      // Nulls always sort to end regardless of direction
      result = arrayPending.concat(arrayNulls);
      return result;
    }
  }
}
